import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain as prepareProductChain,
    PrepareData,
} from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareProduct";
import {
    chain as displayProductChain,
    DispatchCompleteLoadProduct,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { getCurrencyCode, trackGA4ViewItem } from "@thkStore/Common/Utilities/ga4EcommerceTracking";

const SendGA4ViewItemEvent: typeof DispatchCompleteLoadProduct = props => {
    if (!props.product) {
        return;
    }

    const currency = getCurrencyCode(props.getState());
    trackGA4ViewItem(props.product, currency);
};

addToChainAfter(displayProductChain, DispatchCompleteLoadProduct, SendGA4ViewItemEvent);

// On SSR direct-URL loads the DisplayProduct chain is skipped (product already
// loaded from server). ProductDetailsPage.componentDidMount dispatches
// prepareProduct instead — hook into that so view_item still fires.
// trackGA4ViewItem's built-in dedup prevents double-firing on SPA navigation
// where both chains execute.
const SendGA4ViewItemOnPrepare: typeof PrepareData = props => {
    if (!props.parameter.product) {
        return;
    }

    const currency = getCurrencyCode(props.getState());
    trackGA4ViewItem(props.parameter.product, currency);
};

addToChainAfter(prepareProductChain, PrepareData, SendGA4ViewItemOnPrepare);

if (module.hot) {
    module.hot.accept();
    const snapshotDisplayChain = displayProductChain.slice();
    const snapshotPrepareChain = prepareProductChain.slice();
    module.hot.dispose(() => {
        displayProductChain.length = 0;
        snapshotDisplayChain.forEach(o => displayProductChain.push(o));
        prepareProductChain.length = 0;
        snapshotPrepareChain.forEach(o => prepareProductChain.push(o));
    });
}
